export function keyToDisplay(str: String): String {
  return str
    .toLowerCase()
    .split(/ |-/)
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");
}
